import {
  ReviewLifecycleActionType,
  ReviewerType,
  ReviewLifecycleType,
  ReviewLifecycleTerminalState,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Organization} from 'orgs/OrganizationConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';

import {REVIEW_LIFECYCLE_TYPE_TO_DISPLAY_TEXT} from './ReviewLifecyclesListing';

export const SELF_REVIEW_STAGE_DESCRIPTION = 'Self-review stage';
export const SELF_REVIEW_STAGE_NAME = 'Self-review';

export const REVIEWER_TYPE_TO_DISPLAY_TEXT: {[K in ReviewerType]: string} = {
  [ReviewerType.AUTHOR]: 'Author(s)',
  [ReviewerType.PROJECT_MEMBERS]: 'Project collaborators',
  [ReviewerType.TEAM]: 'Team',
};

export const REVIEW_ACTION_TYPE_TO_DISPLAY_TEXT: {[K in ReviewLifecycleActionType]: string} = {
  [ReviewLifecycleActionType.ACCEPT]: 'Accept',
  [ReviewLifecycleActionType.APPROVE]: 'Approve',
  [ReviewLifecycleActionType.COMPLETE]: 'Complete',
  [ReviewLifecycleActionType.REVIEW]: 'Review',
  [ReviewLifecycleActionType.WITNESS]: 'Witness',
  [ReviewLifecycleActionType.SELF_REVIEW]: 'Self-review',
};

export const REVIEW_ACTION_TO_DISPLAY_PAST_TENSE: {[K in ReviewLifecycleActionType]: string} = {
  [ReviewLifecycleActionType.ACCEPT]: 'Accepted',
  [ReviewLifecycleActionType.APPROVE]: 'Approved',
  [ReviewLifecycleActionType.COMPLETE]: 'Completed',
  [ReviewLifecycleActionType.REVIEW]: 'Reviewed',
  [ReviewLifecycleActionType.WITNESS]: 'Witnessed',
  [ReviewLifecycleActionType.SELF_REVIEW]: 'Self-reviewed',
};

export const REVIEW_COMPLETION_STATUS_TO_DISPLAY_TEXT: {[K in ReviewLifecycleTerminalState]: string} = {
  [ReviewLifecycleTerminalState.APPROVED]: 'Approved',
  [ReviewLifecycleTerminalState.COMPLETED]: 'Completed',
  [ReviewLifecycleTerminalState.ACCEPTED]: 'Accepted',
  [ReviewLifecycleTerminalState.REVIEWED]: 'Reviewed',
  [ReviewLifecycleTerminalState.WITNESSED]: 'Witnessed',
  [ReviewLifecycleTerminalState.SELF_REVIEWED]: 'Self-reviewed',
};

export interface ReviewLifecycleStage {
  action: ReviewLifecycleActionType;
  name: string;
  reviewerType: ReviewerType;
  description: string | null;
  selectedTeamId?: string;
  previousVersionReviewLifecycleStageId: string | null;
  isTeamReassignable: boolean | null;
  allowAuthorReviewers: boolean;
  allowSenderReviewer: boolean;
}

export interface ReviewLifecycleVersion {
  lifecycleType: ReviewLifecycleType;
  name: string;
  reviewStages: Array<ReviewLifecycleStage>;
  terminalState: ReviewLifecycleTerminalState;
}

export const getOrganizationOptions = (organizations: Array<Organization>): Array<OptionData> =>
  organizations.map((org: Organization) => ({
    value: org.id,
    name: org.name,
  }));

export const REVIEW_TYPE_OPTION_DATAS: Array<OptionData> = Object.keys(ReviewLifecycleType).map(
  (rlcType: ReviewLifecycleType) => ({
    value: rlcType,
    name: REVIEW_LIFECYCLE_TYPE_TO_DISPLAY_TEXT[rlcType],
  })
);

export const MULTI_STAGE_REVIEW_TYPES = [ReviewLifecycleType.SEQUENTIAL, ReviewLifecycleType.PARALLEL];

export const REVIEWER_TYPE_OPTION_DATAS: Array<OptionData> = Object.keys(ReviewerType).map(
  (reviewerType: ReviewerType) => ({
    value: reviewerType,
    name: REVIEWER_TYPE_TO_DISPLAY_TEXT[reviewerType],
  })
);

export const ACTION_LABEL_OPTION_DATAS: Array<OptionData> = Object.keys(ReviewLifecycleActionType).map(
  (actionType: ReviewLifecycleActionType) => ({
    value: actionType,
    name: REVIEW_ACTION_TYPE_TO_DISPLAY_TEXT[actionType],
  })
);

export const COMPLETION_STATUS_OPTION_DATAS: Array<OptionData> = Object.keys(
  ReviewLifecycleTerminalState
).map((completionStatus: ReviewLifecycleTerminalState) => ({
  value: completionStatus,
  name: REVIEW_COMPLETION_STATUS_TO_DISPLAY_TEXT[completionStatus],
}));
